import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "location",
  "use": "location-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"location\"><defs><style>#location .cls-1{fill:none}</style></defs><title>资源 90</title><g id=\"location_图层_2\" data-name=\"图层 2\"><g id=\"location_图层_1-2\" data-name=\"图层 1\"><g id=\"location_enviroment\"><path id=\"location_Shape\" d=\"M11.46 22.4a27.89 27.89 0 0 1-5-4.49 18 18 0 0 1-2.55-3.85 11 11 0 0 1-1.1-4.6 7.11 7.11 0 0 1 .75-3.14 8.32 8.32 0 0 1 2-2.55 9.57 9.57 0 0 1 2.96-1.72 9.93 9.93 0 0 1 7 0 9.57 9.57 0 0 1 2.88 1.72 8 8 0 0 1 2 2.55 6.88 6.88 0 0 1 .75 3.14 10.7 10.7 0 0 1-1.1 4.61 17.52 17.52 0 0 1-2.54 3.84 27.51 27.51 0 0 1-5 4.49.94.94 0 0 1-1.08 0zM8.65 6.72A4.73 4.73 0 1 0 12 5.33a4.74 4.74 0 0 0-3.35 1.39zm.29 3.35a3.06 3.06 0 1 1 3.07 3 3.06 3.06 0 0 1-3.07-3z\" /></g><path id=\"location_Rectangle_14\" data-name=\"Rectangle 14\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/location.svg
// module id = C5qe
// module chunks = 6